<ng-container *transloco="let t">
  <section>
    <h3 class="main-title">{{ t('inspection.sections.plans') }}</h3>
    <table
      mat-table
      class="mat-elevation-z4 boundary"
      cdkDropList
      [dataSource]="planningDetails.plans"
      [cdkDropListData]="planningDetails.plans"
      [cdkDropListDisabled]="readonly || printPreview"
      (cdkDropListDropped)="drop($event)"
    >
      <ng-container matColumnDef="drag">
        <th mat-header-cell *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let element"
          cdkDrag
          cdkDragRootElement="tr"
          cdkDragLockAxis="y"
          cdkDragBoundary=".boundary"
          [cdkDragData]="element"
        >
          <div cdkDragHandle class="drag-handle">
            <authority-labs-drag-icon></authority-labs-drag-icon>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('inspection.fields.plans:name') }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field>
            <textarea
              matInput
              class="text"
              cdkTextareaAutosize
              name="name"
              [drawableField]="planFieldId(element, 'name')"
              [drawableFieldTitle]="t('inspection.fields.plans:name')"
              [drawableFieldReadonly]="readonly || printPreview"
              [(ngModel)]="element.name"
              [readonly]="readonly || printPreview"
              (input)="onChange()"
            ></textarea>
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="identificationCode">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('inspection.fields.plans:identificationCode') }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field>
            <textarea
              matInput
              class="text"
              cdkTextareaAutosize
              name="identificationCode"
              [drawableField]="planFieldId(element, 'identificationCode')"
              [drawableFieldTitle]="
                t('inspection.fields.plans:identificationCode')
              "
              [drawableFieldReadonly]="readonly || printPreview"
              [(ngModel)]="element.identificationCode"
              [readonly]="readonly || printPreview"
              (input)="onChange()"
            ></textarea>
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="edition">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('inspection.fields.plans:edition') }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field>
            <input
              matInput
              class="text"
              cdkTextareaAutosize
              name="edition"
              [drawableField]="planFieldId(element, 'edition')"
              [drawableFieldTitle]="t('inspection.fields.plans:edition')"
              [drawableFieldReadonly]="readonly || printPreview"
              [(ngModel)]="element.edition"
              [readonly]="readonly || printPreview"
              (input)="onChange()"
            />
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('inspection.fields.plans:date') }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field *ngIf="!(readonly || printPreview)">
            <input
              matInput
              class="text"
              name="date"
              [drawableField]="planFieldId(element, 'date')"
              [drawableFieldTitle]="t('inspection.fields.plans:date')"
              [drawableFieldReadonly]="readonly || printPreview"
              [matDatepicker]="picker"
              [(ngModel)]="element.date"
              (dateInput)="onChange()"
              (dateChange)="onChange()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <mat-form-field *ngIf="readonly || printPreview">
            <input
              matInput
              class="text"
              name="date"
              [drawableField]="planFieldId(element, 'date')"
              [drawableFieldReadonly]="true"
              [ngModel]="element.date | date : 'shortDate'"
              readonly
            />
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('inspection.fields.plans:notes') }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field>
            <textarea
              matInput
              class="text"
              cdkTextareaAutosize
              name="notes"
              [drawableField]="planFieldId(element, 'notes')"
              [drawableFieldTitle]="t('inspection.fields.plans:notes')"
              [drawableFieldReadonly]="readonly || printPreview"
              [(ngModel)]="element.notes"
              [readonly]="readonly"
              (input)="onChange()"
            ></textarea>
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="file">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('inspection.fields.plans:file') }}
        </th>
        <td mat-cell *matCellDef="let element">
          <button mat-button (click)="viewFile(element.fileId)">
            {{ element.fileName }}
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <button mat-icon-button [matMenuTriggerFor]="mainmenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #mainmenu="matMenu">
            <button mat-menu-item (click)="addPlan()">
              {{ t('inspection.fields.plans:addPlan') }}
            </button>
            <button
              mat-menu-item
              (click)="addPlansByDocs()"
              *ngIf="orderId && orderDirectory"
            >
              {{ t('inspection.fields.plans:addPlansFromFiles') }}
            </button>
          </mat-menu>
        </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              (click)="attachDoc(element)"
              *ngIf="orderId && orderDirectory"
            >
              {{ t('inspection.fields.plans:attachFileFromList') }}
            </button>
            <button
              mat-menu-item
              (click)="selectFile(element)"
              *ngIf="orderId && orderDirectory"
            >
              <nz-upload
                [(nzFileList)]="fileList"
                [nzBeforeUpload]="uploadDirectory.beforeUpload"
              >
                {{ t('inspection.fields.plans:uploadNewFile') }}
              </nz-upload>
            </button>
            <button mat-menu-item (click)="remove(element)">
              {{ t('inspection.fields.plans:remove') }}
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </section>
</ng-container>
